import React from "react";
import { QqControlsGroupPropsType } from "./qq-controls-group-props.type";
import { QqControlFactoryRaw } from "./qq-control-factory.raw";

export const QqControlsGroupAdditionalControlRaw: React.FunctionComponent<QqControlsGroupPropsType> =
  ({ group, state, dispatch }) => {
    const ctrlFactory = new QqControlFactoryRaw();

    const controls = group.qq.map((qq) =>
      ctrlFactory.create({ state, dispatch }, qq)
    );

    return (
      <fieldset>
        <legend>{group.label}</legend>
        {controls}
      </fieldset>
    );
  };
